import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/index.css";
import App from "./App";
import "./translations/i18n";
import store from "./store";
import { Provider } from "react-redux";
import { AddressFormProvider } from "./context/AddressFormContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AddressFormProvider>
      <App />
    </AddressFormProvider>
  </Provider>
);
